module.exports = __webpack_public_path__ + "media/images/balance-product-leather-2c04ba42003b8182681de00e7753639b.png";